import GeneralTermsPage from "./components/GeneralTermsPage";

export default GeneralTermsPage;
export { GeneralTermsPage };

